import { Component } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';

@Component({
  selector: 'app-abrir-chamado-d',
  templateUrl: './abrir-chamado-d.component.html',
  styleUrls: ['./abrir-chamado-d.component.scss']
})
export class AbrirChamadoDComponent {
  public queryParams!: Params;
  constructor(private router: ActivatedRoute) {
    this.queryParams = this.router.snapshot.queryParams;
  }
}
